import { useEffect } from "react";
import { useQuery } from "react-query";
import { api } from "services/api";
import { handleRequestError } from "utils/Request";

export type ClosedAttendance = {
  id: string;
  contact_id: string;
  contact_name: string;
  agent_id: string;
  agent_name: string;
  tme: string | null;
  tma: string | null;
  rating: number | null;
  status: number;
  created_at: string;
};

type Params = {
  from: string;
  to: string;
  categoryId?: string;
};

async function fetchClosedAttendances(params: Params): Promise<ClosedAttendance[]> {
  const { data } = await api.get('/support/closed-attendances', {
    params: {
      from: params.from,
      to: params.to,
      ...(params.categoryId ? { category_id: params.categoryId } : {}),
    },
  });
  return data;
}

export function useClosedAttendances(params: Params) {
  const query = useQuery(
    ['closed-attendances', params.from, params.to, params.categoryId],
    () => fetchClosedAttendances(params),
  );

  useEffect(() => {
    if (!query.isError) return;
    handleRequestError(query.error, 'Erro ao listar atendimentos encerrados.');
  }, [query.isError, query.error]);

  return query;
}
